export default {
    // When the bound element is inserted into the DOM...
    inserted: function (el, binding) {
        // Focus the element
        el.focus()

        if (binding.modifiers.select) {
            el.select()
            el.addEventListener('focus', _ => el.select())
        }
    }
}
